"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenchmarkBase = void 0;
;
;
var BenchmarkBase = /** @class */ (function () {
    function BenchmarkBase(logger) {
        this.logger = logger;
    }
    BenchmarkBase.frameCode = function (code, name) {
        return "\n        <!DOCTYPE html>\n        <html>\n          <head>\n            <title>Benchmark</title>\n        \n            <script>\n              function __startInjectedCode() {\n                ".concat(code, "\n              }\n\n              function start() {\n                  try {\n                    const retVal = __startInjectedCode();\n                    window.parent.postMessage({\n                      kind: \"benchmarkTestFinished\",\n                      testId: \"").concat(name, "\",\n                      result: retVal\n                    }, \"*\");\n                  } catch (err) {\n                      window.parent.postMessage({\n                        kind: \"benchmarkTestFailed\",\n                        testId: \"").concat(name, "\",\n                        error: err\n                      }, \"*\");\n                  }\n              }\n            </script>\n        \n          </head>\n        \n          <body onload=\"start()\">\n          </body>\n        \n        </html>        \n        ");
    };
    BenchmarkBase.prototype.runCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var code, startFunctionCode, addFrame, removeFrame, logger;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCode()];
                    case 1:
                        code = _a.sent();
                        this.logger.info("BENCHMARKS runCode, loadedCode length = ".concat(code.length));
                        startFunctionCode = this.createStartFunctionCode(code);
                        addFrame = function (code) {
                            var frameCode = BenchmarkBase.frameCode(code, _this.name);
                            var frame = document.createElement("iframe");
                            frame.id = "benchmarkFrame";
                            frame.style.display = "none";
                            frame.srcdoc = frameCode;
                            document.body.appendChild(frame);
                            return frame;
                        };
                        removeFrame = function (frame) {
                            document.body.removeChild(frame);
                        };
                        logger = this.logger;
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                addEventListener("message", messageEventHandler, false);
                                var frame = addFrame(startFunctionCode);
                                function messageEventHandler(event) {
                                    if (event.data.kind === "benchmarkTestFinished") {
                                        logger.info("".concat(event.data.testId, " executed ").concat(event.data.result, " ms."));
                                        removeEventListener("message", messageEventHandler);
                                        removeFrame(frame);
                                        resolve(event.data.result);
                                    }
                                    else if (event.data.kind === "benchmarkTestFailed") {
                                        logger.error("".concat(event.data.testId, " failed with error: "), event.data.error);
                                        removeEventListener("message", messageEventHandler);
                                        removeFrame(frame);
                                        reject(event.data.error);
                                    }
                                }
                            })];
                }
            });
        });
    };
    Object.defineProperty(BenchmarkBase.prototype, "name", {
        get: function () {
            return this.getBenchmarkName();
        },
        enumerable: false,
        configurable: true
    });
    BenchmarkBase.prototype.measure = function () {
        return __awaiter(this, void 0, void 0, function () {
            var mean, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info("Start benchmark '".concat(this.name, "' measure..."));
                        return [4 /*yield*/, this.runCode()];
                    case 1:
                        mean = _a.sent();
                        result = 100 * this.getReference() / mean;
                        this.logger.info("BENCHMARKS measure, result = ".concat(result));
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return BenchmarkBase;
}());
exports.BenchmarkBase = BenchmarkBase;
//# sourceMappingURL=BenchmarkBase.js.map